export default "/images/upcoin1.png?b62c9b5111d9ccffed8f515eaf9b8f4e";